import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 286983 315656"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#fefefe;stroke-width:3498}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528317590112">
        <path
          d="M220663 109306c-5894 2800-11986 5242-18243 7331v155519h18243V109306zM249611 91109c-6656 5458-13891 10273-21580 14455v186078h21580V91109zM285234 41480c-6174 16893-15952 31257-28259 43087v229340h28259V41480zM1749 41480v272427h28259V84567C17701 72737 7923 58373 1749 41480zM66320 109306v162850h18243V116637c-6257-2089-12354-4531-18243-7331z"
          className="fill "
          style={{
            strokeWidth: 3498,
          }}
        />
        <path
          d="M63845 99849c354 119 684 299 978 514 6500 3388 13322 6303 20378 8745 1198 413 2401 817 3612 1203 372 55 730 170 1056 335 17040 5325 35315 7988 53623 7988 18307 0 36582-2663 53622-7988 326-165 684-275 1060-335 1208-386 2410-790 3608-1203 7056-2442 13878-5357 20378-8745 294-215 624-390 978-514 35237-18702 60765-51405 62041-98100h-551c-42311 110710-239967 110710-282273 0h-551c1276 46695 26804 79398 62041 98100z"
          className="fill "
          style={{
            strokeWidth: 3498,
          }}
        />
        <path
          d="M246407 1749H40576c54109 45956 151722 45961 205831 0z"
          className="fill "
          style={{
            strokeWidth: 3498,
          }}
        />
        <path
          d="M257319 1749c-28705 27888-71291 41834-113827 41834-42537 0-85132-13946-113832-41834H10264c41669 100914 224786 100910 266459 0h-19404zM37372 91109v200533h21580V105564c-7685-4182-14924-9002-21580-14455z"
          className="fill "
          style={{
            strokeWidth: 3498,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
